import React from "react";
import MyProjects from "../../MyProjects/MyProjects";
import About from "../../About/About";
import Contact from "../../Contact/Contact";
import TopBanner from "../TopBanner/TopBanner";
import MyExperience from "../../MyExperience/MyExperience";

const Home = () => {
  return (
    <div>
      <TopBanner />
      <About />
      <MyExperience />
      <MyProjects />
      <Contact />
    </div>
  );
};

export default Home;
